import { createSlice } from '@reduxjs/toolkit';
import { getDateTime, magicNumbers } from 'utils';
import { seenAllNotifications, fetchNotifications } from './actions';

export const notificationInitialState = {
  notifications: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  unseen: 0,
  newVersion: undefined,
  isNewVersionModalOpen: false,
};
export const notificationSlice = createSlice({
  name: 'notificationSlice',
  initialState: notificationInitialState,
  reducers: {
    updateCurrentDownloadingNotification: (state, action) => {
      const { updatedNotification } = action.payload;
      const { date, time } = getDateTime(null, 'm');
      const finalUpdatedNotification = {
        ...updatedNotification,
        time: `${date} ${time}`,
      };
      const updatedNotificationIndex = state.notifications?.data?.findIndex(
        (_notification) => _notification?.id === finalUpdatedNotification?.id
      );

      if (updatedNotificationIndex === magicNumbers.INDEX_NOT_FOUND) {
        state.notifications.data.unshift(finalUpdatedNotification);
        state.unseen = state.unseen + 1;
      } else {
        state.notifications.data[updatedNotificationIndex] =
          finalUpdatedNotification;
      }
    },
    addNotification: (state, action) => {
      const { notification } = action.payload;
      const { date, time } = getDateTime(null, 'm');
      notification.time = `${date} ${time}`;
      state.notifications.data.unshift(notification);
      state.unseen = state.unseen + 1;
    },
    setNewVersion: (state, action) => {
      state.newVersion = action.payload.newVersion;
    },
    changeNewVersionModalState: (state, action) => {
      state.isNewVersionModalOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(seenAllNotifications.fulfilled, (state) => {
        state.unseen = 0;
        state.notifications.data = state.notifications.data?.map((notif) => ({
          ...notif,
          isRead: true,
        }));
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        const {
          notifications,
          unseenCount,
          newVersion,
          total = 0,
        } = action.payload;
        state.notifications.data = notifications;
        state.unseen = unseenCount;
        if (newVersion) {
          state.newVersion = newVersion;
        }
        state.notifications.total = total;
        state.notifications.loading = false;
        state.notifications.error = null;
      })
      .addCase(fetchNotifications.pending, (state) => {
        state.notifications.loading = true;
        state.notifications.error = null;
        state.notifications.total = 0;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.notifications.loading = false;
        state.notifications.error = action.payload;
        state.notifications.total = 0;
      });
  },
});

export const {
  updateCurrentDownloadingNotification,
  addNotification,
  setNewVersion,
  changeNewVersionModalState,
} = notificationSlice.actions;
